import './styles.css'

import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { Elements } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faTimes } from '@fortawesome/free-solid-svg-icons'

import {
  Card,
  Typography,
  Box,
  Container,
  CardContent,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  CardActions,
} from '@mui/material'
// import CloseIcon from '@mui/icons-material/Close'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'

import actionTypes from 'store/actions'
import SubscriptionModal from 'components/Common/Modal/SubscriptionModal'
import MainLayout from 'layouts/mainLayout'

import { PRIMARY_BUTTON } from 'themes/theme'
import Button from 'components/Common/Button'
import ZendeskLink from 'components/Common/ZendeskLink'

const fonts = [
  {
    cssSrc: 'https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap',
  },
]

export function WelcomePage({ onClose }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const stripePromise = loadStripe(process.env['REACT_APP_STRIPE_PUBLIC_KEY'])
  const isModalStepOpen = useSelector(state => state.appReducer.isOpenSubscriptionModal)

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [navigate])

  const modalHandler = useCallback(
    value => {
      dispatch({ type: actionTypes.TOGGLESUBSCRIPTIONMODAL, data: value })
      dispatch({ type: actionTypes.TOGGLECOMPANYNAMEMODAL, data: value })
    },
    [dispatch],
  )

  const onKeyPress = useCallback(
    event => {
      if (event.code === 'Escape') {
        onClose ? onClose() : navigate(-1)
      }
    },
    [onClose, navigate],
  )

  useEffect(() => {
    window.addEventListener('keydown', onKeyPress)
    return () => {
      window.removeEventListener('keydown', onKeyPress)
    }
  }, [onKeyPress])

  return (
    <MainLayout>
      <Box className="bg-white" color="#25245f">
        <div className="d-flex justify-content-end align-items-end p-4">
          <Button onClick={() => navigate(-1)} type={PRIMARY_BUTTON}>
            Exit
          </Button>
        </div>
        <Container maxWidth="md">
          <Typography variant="h5" component="h3" className="text-center ln15">
            As business owners ourselves, we know how important it is to know what's coming.
          </Typography>
          <Container maxWidth="sm" className="text-center mt-2">
            <Typography sx={{ fontSize: '14px', marginTop: '20px' }}>
              Our membership model is simple and affordable - no hidden fees or surprises. Check out what our membership
              can do for your business.
            </Typography>
          </Container>
          <Box className="row mt-2">
            <Box className="col-sm-12 text-center">
              <Typography className="ln15 px-5 my-3" variant="h6">
                Limited Time Only: Get the first month of the Dashboard free with promotional code GROW23
              </Typography>
            </Box>
            <Box className="col-sm-12 col-md-6">
              <Card className="customCardWelcome">
                <Typography className="cardTitle p-3" variant="h6">
                  Starter (Free)
                </Typography>
                <CardContent className="customCardBody">
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon sx={{ fontSize: 30 }} style={{ color: '#66668f' }} />
                      </ListItemIcon>
                      <ListItemText secondary={'View limited information on partners and other businesses'} />
                    </ListItem>
                    <Divider variant="fullWidth" component="li" />
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon sx={{ fontSize: 30 }} style={{ color: '#66668f' }} />
                      </ListItemIcon>
                      <ListItemText secondary={'Search over 100 million pre-verified businesses'} />
                    </ListItem>
                  </List>
                </CardContent>
              </Card>
            </Box>
            <Box className="col-sm-12 col-md-6">
              <Card className="customCardWelcome">
                <Typography className="cardTitle p-3" variant="h6">
                  Premium ($49.99/mo)
                </Typography>
                <CardContent className="customCardBody">
                  <List>
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon sx={{ fontSize: 30 }} style={{ color: '#66668f' }} />
                      </ListItemIcon>
                      <ListItemText
                        secondary={
                          'Take advantage of member-only benefits, including insights and guidance from industry experts and access to special offers'
                        }
                      />
                    </ListItem>
                    <Divider variant="fullWidth" component="li" />
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon sx={{ fontSize: 30 }} style={{ color: '#66668f' }} />
                      </ListItemIcon>
                      <ListItemText
                        secondary={'Claim your business on Markaaz and be in charge of your business data'}
                      />
                    </ListItem>
                    <Divider variant="fullWidth" component="li" />
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon sx={{ fontSize: 30 }} style={{ color: '#66668f' }} />
                      </ListItemIcon>
                      <ListItemText
                        secondary={
                          'Get real-time business insights (cashflow, sales, customer engagement, social media, and more)'
                        }
                      />
                    </ListItem>
                    <Divider variant="fullWidth" component="li" />
                    <ListItem>
                      <ListItemIcon>
                        <CheckCircleIcon sx={{ fontSize: 30 }} style={{ color: '#66668f' }} className="iconPlace" />
                      </ListItemIcon>
                      <ListItemText
                        secondary={
                          'Store your key business documents securely in the Vault to have them at your fingertips'
                        }
                      />
                    </ListItem>
                  </List>
                  <Typography
                    variant="h4"
                    component="h4"
                    class="text-center px-5 font-weight-bold mt-1"
                    color="primary"
                  >
                    <b className="promoText">
                      Save 20% and get an annual <br /> membership for $479.90!
                    </b>
                  </Typography>
                </CardContent>
                <CardActions className="mb-2 px-5">
                  <Button
                    size="large"
                    sx={{ marginTop: '20px' }}
                    onClick={() => dispatch({ type: actionTypes.TOGGLESUBSCRIPTIONMODAL, data: true })}
                    fullWidth
                    type={PRIMARY_BUTTON}
                  >
                    Get Started
                  </Button>
                </CardActions>
              </Card>
            </Box>
          </Box>
        </Container>

        <Elements stripe={stripePromise} options={{ fonts: fonts }}>
          <SubscriptionModal isModalOpen={isModalStepOpen} setModalOpen={modalHandler} />
        </Elements>
      </Box>
      <ZendeskLink />
    </MainLayout>
  )
}
